import { render, staticRenderFns } from "./ConfigurationDirectMatchRouterView.vue?vue&type=template&id=6165b7c0&scoped=true&"
import script from "./ConfigurationDirectMatchRouterView.vue?vue&type=script&lang=js&"
export * from "./ConfigurationDirectMatchRouterView.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationDirectMatchRouterView.vue?vue&type=style&index=0&id=6165b7c0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6165b7c0",
  null
  
)

export default component.exports